import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Icon from "components/Library/Icon";

import styles from "./NewNavigation.css";

class SearchWindow extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      search: null,
    };

    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleChange = this._handleChange.bind(this);
  }

  _handleSubmit(event) {
    event.preventDefault();
    this.props.history.push({
      pathname: "/results",
      search: `?q=${this.state.search}`,
    });
  }

  _handleChange(e) {
    this.setState({
      search: e.target.value,
    });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} className="gtm-nav-search">
        <div role="search" className={styles.searchWindow}>
          <input
            onChange={this.handleChange}
            className={styles.dropdownInput}
            placeholder="Search Axios"
          />
          <button
            type="submit"
            aria-label="Submit Axios Search"
            className={styles.searchSubmit}
            onBlur={this.props.onBlur}
            ref={this.props.searchRef}
          >
            <Icon name="search" className={styles.searchIcon} />
          </button>
        </div>
      </form>
    );
  }
}

export default withRouter(SearchWindow);

SearchWindow.propTypes = {
  history: PropTypes.object.isRequired,
  onBlur: PropTypes.func,
  searchRef: PropTypes.object,
};
